/* Header Menu Custom Icon setting 
let menus = document.querySelectorAll(".header__menu-item.list-menu__item.link--text");
let menu_icon_list = document.querySelector("header.header").dataset.menuicons;
console.log(menu_icon_list);
//console.log('<img src=\"//enchanteur.in/cdn/shop/files/wishlist_24x24.png?v=3292897131041042311" />');
menus.forEach(function(item, index){
  //console.log(item);
  let itemText = convertToSlug(item.textContent.replace(/(^\s*(?!.+)\n+)|(\n+\s+(?!.+)$)/g, "").trim()) + ".png";
  console.log(itemText);
  //console.log(itemText.includes('wishlist'));
  //console.log(itemText.replace(/(^\s*(?!.+)\n+)|(\n+\s+(?!.+)$)/g, "").trim());
  //console.log(item.parentElement.parentElement.classList);
  //str.includes("Geeks");
  if(menu_icon_list.includes(itemText)){
  
  }
  if(item.parentElement.parentElement.classList.contains("header__submenu")){
    item.innerHTML = "<img src=\"//enchanteur.in/cdn/shop/files/wishlist_24x24.png?v=3292897131041042311\" />" + item.innerHTML;
  } else{
    item.innerHTML = "<img src=\"//enchanteur.in/cdn/shop/files/wishlist_24x24.png?v=3292897131041042311\" />" + item.innerHTML;
  }
  
}); */

function convertToSlug(Text) {
  return Text.toLowerCase()
             .replace(/ /g, '-')
             .replace(/[^\w-]+/g, '');
}

/* Header Announcement Bar */
console.log(document.querySelector('.announcement-bar-swiper'));
// if(document.querySelector('.announcement-bar-swiper')){
//   const swiperAnnouncementBar = new Swiper(".announcement-bar-swiper", {
//     slidesPerView: 1,
//     autoplay: true,
//     speed: 400,
//     loop: true,
//   });
// }

/* Homepage Collection List carousal */
const swiper = new Swiper('body.index .section-collection-list .swiper', {
  // Default parameters
  //loop: true,
  slidesPerView: 4.65,
  //spaceBetween: 20,
  grabCursor: true,
  preventInteractionOnTransition: false,
  preventClicks: false,
  preventClicksPropagation: false,
  allowSwipeToNext: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  //centeredSlides: true,
  breakpoints: {
    667: {
      slidesPerView: 5
    }
  }
})

//console.log(swiper);

/* Homepage Bestseller carousal */
const swiperBestseller = new Swiper('body.index .section-featured-collection .swiper', {
  // Default parameters
  loop: true,
  grabCursor: true,
  slidesPerView: 2.15,
  spaceBetween: 10,
  preventInteractionOnTransition: false,
  preventClicks: false,
  preventClicksPropagation: false,
  allowSwipeToNext: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  centeredSlides: true,
  breakpoints: {
    667: {
      slidesPerView: 4,
      spaceBetween: 15
    }
  }
});

/* Homepage Blog section carousal */
const swiperBlogs = new Swiper('body.index .section-featured-blog .swiper', {
  // Default parameters
  //loop: true,
  slidesPerView: 1,
  //spaceBetween: 10,
  preventInteractionOnTransition: false,
  preventClicks: false,
  preventClicksPropagation: false,
  allowSwipeToNext: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  //centeredSlides: true,
  breakpoints: {
    667: {
      slidesPerView: 3,
      spaceBetween: 15
    }
  }
});

/* Collection page Load More button */
if(document.querySelector('.js-load-more')){
    document.querySelector('.js-load-more').addEventListener('click', function(){
    var $this = this; //document.querySelector(this);
    var totalPages = parseInt(document.querySelector('[data-total-pages]').value),currentPage = parseInt(document.querySelector('[data-current-page]').value);
    //console.log($this);
    $this.setAttribute('disabled', true);
    $this.querySelector('[loader]').classList.remove('hidden');
    currentPage = currentPage+1;
    var nextUrl = document.querySelector('[data-next-url]').value.replace(/page=[0-9]+/,'page='+currentPage);
    document.querySelector('[data-current-page]').value = currentPage;

    //console.log(nextUrl);

    var request = new XMLHttpRequest();

    request.open("GET", nextUrl);

    request.responseType = "document";

    request.onreadystatechange = function() {
      // Check if the request is compete and was successful
      if(this.readyState === 4 && this.status === 200) {
        var response = this.response;
        //console.log(response.getElementById('product-grid').innerHTML);
        // Inserting the response from server into an HTML element
        //console.log(response.querySelectorAll('.shopify-payment-button__button--unbranded'));
//         response.querySelectorAll('.shopify-payment-button__button--unbranded').forEach(function(item, index){
//           console.log(item);
//           item.classList.remove('shopify-payment-button__button--hidden'); 
//           item.removeAttribute('disabled');
//         });
        
        console.log('payment_button');
        
        document.getElementById('product-grid').lastElementChild.insertAdjacentHTML("afterend", response.getElementById('product-grid').innerHTML);
        if(currentPage < totalPages) {
          $this.removeAttribute('disabled', false); 
          $this.querySelector('[load-more-text]').classList.remove('hidden'); 
          $this.querySelector('[loader]').classList.add('hidden');
        } else {
          $this.setAttribute('disabled', false); 
          document.querySelector('.load-more_wrap').classList.add('hidden'); 
        }
      }
    };

    // Sending the request to the server
    request.send();
      
    // Initialize shopify payment buttons
//         if (Shopify.PaymentButton) {
//           console.log("Shopify.PaymentButton");
//           Shopify.PaymentButton.init();
//         }
  });
}

/* Product page Fragrance Notes section carousal */
const swiperFragranceNotes = new Swiper('body.product .section-fragrance-notes .swiper', {
  // Default parameters
  //loop: true,
  slidesPerView: 3,
  spaceBetween: 10,
  preventInteractionOnTransition: false,
  preventClicks: false,
  preventClicksPropagation: false,
  allowSwipeToNext: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  //centeredSlides: true,
  breakpoints: {
    667: {
      slidesPerView: 3,
      spaceBetween: 15
    }
  }
});

/* Product page media gallary */
var swiperProductMedia = new Swiper("body.product media-gallery.product__media-gallery .swiper", {
  pagination: {
    el: ".swiper-pagination",
  },
});

// /* Product page Product Recommendations / Customer Also Bought Viewed section carousal */
// const swiperProductRecommendations = new Swiper('body.product .section-product-recommendations .swiper', {
//   // Default parameters
//   //loop: true,
//   slidesPerView: 2,
//   spaceBetween: 5,
//   preventInteractionOnTransition: false,
//   preventClicks: false,
//   preventClicksPropagation: false,
//   allowSwipeToNext: false,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   //centeredSlides: true,
//   breakpoints: {
//     667: {
//       slidesPerView: 3,
//       spaceBetween: 10
//     }
//   }
// });

//console.log(swiperProductRecommendations);

/* Product page Shop Product Range section carousal */
const swiperShopProductRange = new Swiper('body.product .section-shop-product-range .swiper', {
  // Default parameters
  loop: true,
  slidesPerView: 2,
  spaceBetween: 10,
  preventInteractionOnTransition: false,
  preventClicks: false,
  preventClicksPropagation: false,
  allowSwipeToNext: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  centeredSlides: true,
  breakpoints: {
    667: {
      slidesPerView: 4,
      spaceBetween: 15
    }
  }
});

/* Cart page Frequently Bought Together section carousal */
const swiperFrequentlyBoughtTogether = new Swiper('body.cart .section-shop-product-range .swiper', {
  // Default parameters
  loop: true,
  slidesPerView: 2,
  spaceBetween: 10,
  preventInteractionOnTransition: false,
  preventClicks: false,
  preventClicksPropagation: false,
  allowSwipeToNext: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  centeredSlides: true,
  breakpoints: {
    667: {
      slidesPerView: 4,
      spaceBetween: 15
    }
  }
});

// /* Product page Product Recently Viewed section carousal */
// const swiperRecentlyViewed = new Swiper('body.product .section-recently-viewed .swiper', {
//   // Default parameters
//   loop: true,
//   slidesPerView: 2,
//   spaceBetween: 5,
//   preventInteractionOnTransition: false,
//   preventClicks: false,
//   preventClicksPropagation: false,
//   allowSwipeToNext: false,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   centeredSlides: true,
//   breakpoints: {
//     667: {
//       slidesPerView: 3,
//       spaceBetween: 10
//     }
//   }
// });// cart drawer checkout 
document.querySelector('.wizz-checkout-button').addEventListener('click', function () {
    onCheckoutClick(this);
});